import "./Hero.scss";
import "intersection-observer";

import React, { useRef } from "react";
import { useInViewport } from "react-in-viewport";

import essayMetadata, {
  EssayID,
  orderedEssayIDs,
} from "../essays/essayMetadata";
import MobileEssayList from "./CompactEssayList";
import BlockField from "./BlockField";
import useViewportSize from "./hooks/useViewportSize";

interface HeroProps {
  essay: EssayID;
}

export default function Hero(props: HeroProps) {
  const viewportSize = useViewportSize();

  const containerRef = useRef<HTMLDivElement | null>(null);
  const { inViewport } = useInViewport(
    containerRef,
    { rootMargin: "200px" },
    { disconnectOnLeave: false },
    {},
  );

  const applicationPromptInsert = (
    <>{essayMetadata[props.essay].hasApplicationPrompts ? " and apply" : ""}</>
  );
  return (
    <div className="HeroContainer" ref={containerRef}>
      <div className="BackgroundFade" />
      <div className="BlockFieldContainer">
        {inViewport && <BlockField key={viewportSize[0].toString()} />}
      </div>
      <div className="HeroContents">
        <h1>
          {essayMetadata[props.essay].title.split("\n").map((line, index) => (
            <span key={`${index}-${line}`}>
              {index > 0 && <br />}
              {line}
            </span>
          ))}
        </h1>
        <div className="MobileSubtitle">
          <p className="Authors">
            <a href="https://andymatuschak.org">Andy Matuschak</a> and{" "}
            <a href="http://michaelnielsen.org">Michael Nielsen</a>
          </p>
          <div className="EssayListing">
            <p>
              Part of a <a href="/">series of essays</a> in a mnemonic medium
              which makes it almost effortless to remember
              {applicationPromptInsert} what&nbsp;you&nbsp;read.
            </p>
            <MobileEssayList
              orderedEssayIDs={orderedEssayIDs}
              activeEssayID={props.essay}
            />
          </div>
        </div>
        <div className="DesktopSubtitle">
          <p className="Authors">
            by <a href="https://andymatuschak.org">Andy Matuschak</a> and{" "}
            <a href="http://michaelnielsen.org">Michael Nielsen</a>
          </p>
          <p className="Tagline">
            Presented in a new mnemonic medium which makes it almost effortless
            to remember{applicationPromptInsert} what you read.
          </p>
        </div>
      </div>
    </div>
  );
}
